import { Link } from "react-router-dom";

export default function Banner() {
  return (
    <div className="relative min-h-[92vh] flex items-center justify-center overflow-hidden">
      {/* Background image with dark overlay */}
      <div className="absolute inset-0">
        <img
          src="https://cdn.pixabay.com/photo/2018/10/01/09/21/pets-3715733_1280.jpg"
          alt="Happy pets"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/80 via-slate-900/60 to-slate-800/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <p className="inline-block text-amber-400 text-sm font-semibold uppercase tracking-widest mb-4 bg-amber-400/10 px-4 py-1.5 rounded-full border border-amber-400/30">
          🐾 Your next best friend is waiting
        </p>
        <h1 className="text-5xl sm:text-7xl font-bold text-white leading-tight mb-6">
          Find Your{" "}
          <span className="text-amber-400">Perfect</span>{" "}
          Companion
        </h1>
        <p className="text-lg sm:text-xl text-slate-300 mb-10 max-w-2xl mx-auto leading-relaxed">
          Healthy, happy pets raised with love — ready to become part of your
          family.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link
            to="/explore"
            className="px-8 py-3.5 bg-amber-400 text-slate-900 rounded-full font-bold text-base hover:bg-amber-300 transition-all duration-300 shadow-lg hover:shadow-amber-400/30 hover:-translate-y-0.5"
          >
            Explore Pets
          </Link>
          <a
            href="#about"
            className="px-8 py-3.5 bg-white/10 text-white border border-white/20 rounded-full font-semibold text-base hover:bg-white/20 backdrop-blur-sm transition-all duration-300 hover:-translate-y-0.5"
          >
            Learn About Us
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1.5 text-white/50">
        <span className="text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-px h-8 bg-white/30 relative overflow-hidden">
          <div className="absolute top-0 w-full bg-amber-400 animate-bounce h-1/2" />
        </div>
      </div>
    </div>
  );
}
